import {RootState} from "../../types";

export const getSocketState = (state: RootState) => state.app.socketState;